"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lowerFirstLetter = void 0;
var lowerFirstLetter = function (value) { return "".concat(value[0].toLocaleLowerCase()).concat(value.slice(1)); };
exports.lowerFirstLetter = lowerFirstLetter;
//# sourceMappingURL=lowerFirstLetter.js.map